import {DispatchEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {DispatchAction} from "./DispatchActionMenu";
import {useDispatchMutation} from "../../../hooks/useDispatchMutation";

export type UseDispatchActionProps = {}

export type UseDispatchActionResult = {
  onDispatchActionClick: (dispatch: DispatchEntity, action: DispatchAction) => void;
}

export const useDispatchAction = (props: UseDispatchActionProps = {}): UseDispatchActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteDispatch,
  } = useDispatchMutation()

  const _onDispatchActionClick = useCallback((dispatch: DispatchEntity, action: DispatchAction) => {
    if (action === "EDIT") {
      navigate(`/dispatch/form`, {state: {id: dispatch.id}})
    } else if (action === "DELETE") {
      deleteDispatch(dispatch.id, undefined)
    }
  }, [navigate, deleteDispatch])

  return {
    onDispatchActionClick: _onDispatchActionClick
  }
}
